
const ROOT = '/society-user-management'

const societyUserManagementPaths = {
  root: ROOT,
  addUser: `${ROOT}/add-user`,
};

export default societyUserManagementPaths;
